/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import env from '../../../env';
import { Button, ErrorMessage } from '../../../components';
import { CartSummary } from '../cartSummary/summary';
import { useForm } from '../../../form';
import { fb } from '../../../form';
import { address } from '../cartShipping/shippingFormData';
import utils from '../../../utils';

/**
 * Your Details step for live-feed-only cart. Collects full billing information;
 * on Next calls saveShippingInfo with Pickup and billing. Uses the same payment flow (Pay component) after.
 */
export function LiveFeedContact({ cart, saveShipping, post, cartId: cartIdProp }) {
  const data = cart?.billingAddress || cart?.shippingAddress || {};
  const model = React.useMemo(() => fb.group({
    billingInfo: address(data),
  }), []);
  const form = useForm(model, { usePlaceholder: true });
  const billingInfo = model.find('billingInfo');
  const render = (name) => form.renderControl(name, billingInfo);
  const cartId = cartIdProp ?? env.getDevCartId();

  const next = (e) => {
    form.validateForm(e, () => {
      const val = form.getValue();
      saveShipping({
        cartId,
        shippingMethod: 'Pickup',
        useSameAddress: true,
        shippingCountry: 'Australia',
        billingInfo: val.billingInfo || {},
        shippingInfo: null,
      });
      utils.ui.scrollTo('#ecmcart');
    });
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-9">
          <form>
            <h3>Your details</h3>
            <p className="text-muted">Please enter your billing details before payment.</p>
            <h4 style={{ marginTop: '1rem' }}>Billing address</h4>
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="form-group">{render('firstName')}</div>
              </div>
              <div className="col-12 col-md-6">
                <div className="form-group">{render('surname')}</div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="form-group">{render('street1')}</div>
                <div className="form-group">{render('street2')}</div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-4">
                <div className="form-group">{render('suburb')}</div>
              </div>
              <div className="col-12 col-md-4">
                <div className="form-group">{render('state')}</div>
              </div>
              <div className="col-12 col-md-4">
                <div className="form-group">{render('postcode')}</div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="form-group">{render('email')}</div>
              </div>
              <div className="col-12 col-md-6">
                <div className="form-group">{render('mobile')}</div>
              </div>
            </div>
          </form>
          <div className="form__actions" style={{ marginTop: '1rem' }}>
            <Button onClick={next} status={form.status}>Next: Pay</Button>
            <ErrorMessage errors={form.errors} summaryMessage="Please review the errors." />
            <ErrorMessage errors={post.errors} />
          </div>
        </div>
        <div className="col-md-3">
          <CartSummary cart={cart} />
        </div>
      </div>
    </div>
  );
}
